import { useQuery } from '@tanstack/react-query';

import { listSites } from '@/api/site-api';

const SITES_KEY = ['sites'] as const;

/**
 * Lists every site the authenticated user can access (contract `Site`
 * objects from `/v1/sites`). Site selection lists in the wizard and the
 * landing filter dropdown both consume this.
 */
export function useSites() {
  return useQuery({
    queryKey: SITES_KEY,
    queryFn: () => listSites(),
  });
}
